module.exports = __webpack_public_path__ + "img/r-logo-white.181f6077.svg";